import React, { useState, useEffect } from 'react';
import { getStats, updateStats } from '../services/statsService';

const StatsAdmin = () => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [fetchLoading, setFetchLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('irc-tv');

  useEffect(() => {
    fetchCurrentStats();
  }, []);

  const fetchCurrentStats = async () => {
    try {
      setFetchLoading(true);
      const data = await getStats();
      setStats(data || {});
    } catch (error) {
      console.error('Error fetching stats:', error);
      setMessage('Error fetching current statistics');
    } finally {
      setFetchLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStats(prev => ({
      ...prev,
      [name]: value
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage('');

  try {
    // Clean the data before sending - remove id and created_at
    const { id, created_at, ...cleanStats } = stats;
    
    console.log('Sending cleaned stats data to server:', cleanStats);
    const result = await updateStats(cleanStats);
    console.log('Update successful:', result);
    setMessage('Statistics updated successfully!');
    
    // Refresh to get the latest data
    setTimeout(() => {
      fetchCurrentStats();
    }, 1000);
  } catch (error) {
    console.error('Update failed:', error);
    setMessage('Error updating statistics: ' + error.message);
  } finally {
    setLoading(false);
  }
};

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  if (fetchLoading) {
    return <div className="loading">Loading current statistics...</div>;
  }

  const TabContent = () => {
    switch (activeTab) {
      case 'irc-tv':
        return (
          <div className="tab-content">
            <h3>IRC TV Statistics</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Subscribers:</label>
                <input
                  type="number"
                  name="subscribers"
                  value={stats.subscribers || ''}
                  onChange={handleChange}
                  placeholder="4200000"
                />
              </div>
              <div className="form-group">
                <label>Views:</label>
                <input
                  type="number"
                  name="views"
                  value={stats.views || ''}
                  onChange={handleChange}
                  placeholder="1100000000"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="tv_updated_date"
                  value={formatDateForInput(stats.tv_updated_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-charity':
        return (
          <div className="tab-content">
            <h3>IRC Charity Clinics</h3>
            
            <h4>Baijipura Clinic</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Treated:</label>
                <input
                  type="number"
                  name="baijipura_patients"
                  value={stats.baijipura_patients || ''}
                  onChange={handleChange}
                  placeholder="222057"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="baijipura_date"
                  value={formatDateForInput(stats.baijipura_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Kiradpura Clinic</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Treated:</label>
                <input
                  type="number"
                  name="kiradpura_patients"
                  value={stats.kiradpura_patients || ''}
                  onChange={handleChange}
                  placeholder="24994"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="kiradpura_date"
                  value={formatDateForInput(stats.kiradpura_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Shah Bazar Clinic</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Treated:</label>
                <input
                  type="number"
                  name="shahbazar_patients"
                  value={stats.shahbazar_patients || ''}
                  onChange={handleChange}
                  placeholder="18061"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="shahbazar_date"
                  value={formatDateForInput(stats.shahbazar_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Shahnoorwadi Clinic</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Treated:</label>
                <input
                  type="number"
                  name="shahnoorwadi_patients"
                  value={stats.shahnoorwadi_patients || ''}
                  onChange={handleChange}
                  placeholder="50175"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="shahnoorwadi_date"
                  value={formatDateForInput(stats.shahnoorwadi_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Misarwadi Clinic</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Treated:</label>
                <input
                  type="number"
                  name="misarwadi_patients"
                  value={stats.misarwadi_patients || ''}
                  onChange={handleChange}
                  placeholder="31329"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="misarwadi_date"
                  value={formatDateForInput(stats.misarwadi_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Buddi Lane Clinic</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Treated:</label>
                <input
                  type="number"
                  name="buddilane_patients"
                  value={stats.buddilane_patients || ''}
                  onChange={handleChange}
                  placeholder="37608"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="buddilane_date"
                  value={formatDateForInput(stats.buddilane_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-dental':
        return (
          <div className="tab-content">
            <h3>IRC Dental Clinics</h3>
            
            <h4>Baijipura Dental Clinic</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Treated:</label>
                <input
                  type="number"
                  name="dental_baijipura_patients"
                  value={stats.dental_baijipura_patients || ''}
                  onChange={handleChange}
                  placeholder="13238"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="dental_baijipura_date"
                  value={formatDateForInput(stats.dental_baijipura_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Kiradpura Dental Clinic</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Treated:</label>
                <input
                  type="number"
                  name="dental_kiradpura_patients"
                  value={stats.dental_kiradpura_patients || ''}
                  onChange={handleChange}
                  placeholder="2179"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="dental_kiradpura_date"
                  value={formatDateForInput(stats.dental_kiradpura_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Buddi Lane Dental Clinic</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Treated:</label>
                <input
                  type="number"
                  name="dental_buddilane_patients"
                  value={stats.dental_buddilane_patients || ''}
                  onChange={handleChange}
                  placeholder="0"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="dental_buddilane_date"
                  value={formatDateForInput(stats.dental_buddilane_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-pathology':
        return (
          <div className="tab-content">
            <h3>IRC Pathology Laboratory</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Patients Tested:</label>
                <input
                  type="number"
                  name="pathology_patients"
                  value={stats.pathology_patients || ''}
                  onChange={handleChange}
                  placeholder="24152"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="pathology_date"
                  value={formatDateForInput(stats.pathology_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-study':
        return (
          <div className="tab-content">
            <h3>IRC Study Centre</h3>
            
            <h4>Roshan Gate Centre</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Students:</label>
                <input
                  type="number"
                  name="study_roshangate_students"
                  value={stats.study_roshangate_students || ''}
                  onChange={handleChange}
                  placeholder="151728"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="study_roshangate_date"
                  value={formatDateForInput(stats.study_roshangate_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Central Naka Centre</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Students:</label>
                <input
                  type="number"
                  name="study_centralnaka_students"
                  value={stats.study_centralnaka_students || ''}
                  onChange={handleChange}
                  placeholder="662"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="study_centralnaka_date"
                  value={formatDateForInput(stats.study_centralnaka_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-technical':
        return (
          <div className="tab-content">
            <h3>IRC Technical Institutes</h3>
            
            <h4>Baijipura Institute</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Students Admitted:</label>
                <input
                  type="number"
                  name="technical_baijipura_students"
                  value={stats.technical_baijipura_students || ''}
                  onChange={handleChange}
                  placeholder="198"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="technical_baijipura_date"
                  value={formatDateForInput(stats.technical_baijipura_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Lasur Institute</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Students Admitted:</label>
                <input
                  type="number"
                  name="technical_lasur_students"
                  value={stats.technical_lasur_students || ''}
                  onChange={handleChange}
                  placeholder="416"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="technical_lasur_date"
                  value={formatDateForInput(stats.technical_lasur_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Khuldabad Institute</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Students Admitted:</label>
                <input
                  type="number"
                  name="technical_khuldabad_students"
                  value={stats.technical_khuldabad_students || ''}
                  onChange={handleChange}
                  placeholder="324"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="technical_khuldabad_date"
                  value={formatDateForInput(stats.technical_khuldabad_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-women':
        return (
          <div className="tab-content">
            <h3>IRC Women Empowerment Centre</h3>
            
            <h4>Baijipura Centre</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Students Admitted:</label>
                <input
                  type="number"
                  name="women_baijipura_students"
                  value={stats.women_baijipura_students || ''}
                  onChange={handleChange}
                  placeholder="324"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="women_baijipura_date"
                  value={formatDateForInput(stats.women_baijipura_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Ambar Hill Centre</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Students Admitted:</label>
                <input
                  type="number"
                  name="women_ambarhill_students"
                  value={stats.women_ambarhill_students || ''}
                  onChange={handleChange}
                  placeholder="331"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="women_ambarhill_date"
                  value={formatDateForInput(stats.women_ambarhill_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Parbhani Centre</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Students Admitted:</label>
                <input
                  type="number"
                  name="women_parbhani_students"
                  value={stats.women_parbhani_students || ''}
                  onChange={handleChange}
                  placeholder="186"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="women_parbhani_date"
                  value={formatDateForInput(stats.women_parbhani_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-call':
        return (
          <div className="tab-content">
            <h3>IRC Helpline</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Total Calls:</label>
                <input
                  type="number"
                  name="total_calls"
                  value={stats.total_calls || ''}
                  onChange={handleChange}
                  placeholder="230611"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="call_centre_date"
                  value={formatDateForInput(stats.call_centre_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-dastarkhwan':
        return (
          <div className="tab-content">
            <h3>IRC Dastarkhwan</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Beneficiaries:</label>
                <input
                  type="number"
                  name="dastarkhwan_beneficiaries"
                  value={stats.dastarkhwan_beneficiaries || ''}
                  onChange={handleChange}
                  placeholder="5246"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="dastarkhwan_date"
                  value={formatDateForInput(stats.dastarkhwan_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-water':
        return (
          <div className="tab-content">
            <h3>IRC Free Water Supply</h3>
            
            <h4>Rohila Gali Unit</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Drinking Water Supply (Liters/Day):</label>
                <input
                  type="number"
                  name="water_rohila_drinking"
                  value={stats.water_rohila_drinking || ''}
                  onChange={handleChange}
                  placeholder="5000"
                />
              </div>
              <div className="form-group">
                <label>Utility Water Supply (Liters/Day):</label>
                <input
                  type="number"
                  name="water_rohila_utility"
                  value={stats.water_rohila_utility || ''}
                  onChange={handleChange}
                  placeholder="10000"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="water_rohila_date"
                  value={formatDateForInput(stats.water_rohila_date)}
                  onChange={handleChange}
                />
              </div>
            </div>

            <h4>Ambar Hill Unit</h4>
            <div className="form-grid">
              <div className="form-group">
                <label>Utility Water Supply (Liters/Day):</label>
                <input
                  type="number"
                  name="water_ambarhill_utility"
                  value={stats.water_ambarhill_utility || ''}
                  onChange={handleChange}
                  placeholder="4000"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="water_ambarhill_date"
                  value={formatDateForInput(stats.water_ambarhill_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-arabic':
        return (
          <div className="tab-content">
            <h3>IRC Arabic Academy</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Student Capacity:</label>
                <input
                  type="number"
                  name="arabic_student_capacity"
                  value={stats.arabic_student_capacity || ''}
                  onChange={handleChange}
                  placeholder="90"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="arabic_date"
                  value={formatDateForInput(stats.arabic_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      case 'irc-minority':
        return (
          <div className="tab-content">
            <h3>IRC Minority Development Center</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Beneficiaries:</label>
                <input
                  type="number"
                  name="minority_beneficiaries"
                  value={stats.minority_beneficiaries || ''}
                  onChange={handleChange}
                  placeholder="597"
                />
              </div>
              <div className="form-group">
                <label>Updated Date:</label>
                <input
                  type="date"
                  name="minority_date"
                  value={formatDateForInput(stats.minority_date)}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  const tabs = [
    { id: 'irc-tv', label: 'IRC TV' },
    { id: 'irc-charity', label: 'IRC Charity' },
    { id: 'irc-dental', label: 'IRC Dental' },
    { id: 'irc-pathology', label: 'IRC Pathology' },
    { id: 'irc-study', label: 'IRC Study' },
    { id: 'irc-technical', label: 'IRC Technical' },
    { id: 'irc-women', label: 'IRC Women' },
    { id: 'irc-call', label: 'IRC Call' },
    { id: 'irc-dastarkhwan', label: 'IRC Dastarkhwan' },
    { id: 'irc-water', label: 'IRC Water' },
    { id: 'irc-arabic', label: 'IRC Arabic' },
    { id: 'irc-minority', label: 'IRC Minority' }
  ];

  return (
    <div className="stats-admin" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ marginBottom: '20px', color: '#333' }}>Update Statistics</h2>
      
      {message && (
        <div 
          className="message" 
          style={{
            padding: '10px',
            marginBottom: '20px',
            backgroundColor: message.includes('Error') ? '#ffebee' : '#e8f5e8',
            color: message.includes('Error') ? '#c62828' : '#2e7d32',
            border: `1px solid ${message.includes('Error') ? '#ffcdd2' : '#c8e6c9'}`,
            borderRadius: '4px'
          }}
        >
          {message}
        </div>
      )}
      
      <div style={{ display: 'flex', gap: '20px', minHeight: '600px' }}>
        {/* Sidebar Tabs */}
        <div style={{ width: '200px', flexShrink: 0 }}>
          <div style={{ 
            backgroundColor: '#f5f5f5', 
            borderRadius: '8px',
            padding: '10px'
          }}>
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  width: '100%',
                  padding: '10px',
                  marginBottom: '5px',
                  backgroundColor: activeTab === tab.id ? '#007bff' : 'transparent',
                  color: activeTab === tab.id ? 'white' : '#333',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  textAlign: 'left'
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div style={{ flex: 1 }}>
          <form onSubmit={handleSubmit} style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px' }}>
            <TabContent />
            
            <button 
              type="submit" 
              disabled={loading}
              style={{
                backgroundColor: loading ? '#ccc' : '#007bff',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '4px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '16px',
                width: '100%',
                marginTop: '20px'
              }}
            >
              {loading ? 'Updating...' : 'Update Statistics'}
            </button>
          </form>
        </div>
      </div>

      <style jsx>{`
        .form-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          margin-bottom: 20px;
        }
        .form-group {
          margin-bottom: 15px;
        }
        .form-group label {
          display: block;
          margin-bottom: 5px;
          font-weight: bold;
          color: #333;
        }
        .form-group input {
          width: 100%;
          padding: 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
        }
        .tab-content h3 {
          margin-bottom: 20px;
          color: #333;
          border-bottom: 2px solid #007bff;
          padding-bottom: 10px;
        }
        .tab-content h4 {
          margin: 20px 0 15px 0;
          color: #555;
          background: #e9ecef;
          padding: 8px 12px;
          border-radius: 4px;
        }
      `}</style>
    </div>
  );
};

export default StatsAdmin;